import React from "react";
import styled from "styled-components";
import Drawer from "../../../aat/components/UI/Drawer/Drawer";
import { PrimaryButton, SecondaryButton } from "../../../aat/components/UI/Button/Button";
import MobileCheckboxFilter, { MobileCheckboxOption } from "./CheckBoxForms/MobileCheckboxFilter";
import MobileDateForm from "./DateRange";
import { Device } from "../../../components/device";
import Icon from "../../../aat/components/Icon/Icon";
import Backdrop from "../../../components/UI/Backdrop/Backdrop";
import { AppState, AppThunkDispatch } from "../../../store";
import { thunkUpdateFilters, thunkResetFilters, ShowFilters } from "../../../store/shows/action";
import { connect } from "react-redux";
import { getShows, getShowFilters, getShowCategories } from "../../../store/shows";
import { format, isValid } from "../../../lib/date";

const MobileFilterWrap = styled.section`
  position: relative;
    .mobile-filter__btn {
        border-radius: 0;
        border: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: currentColor;
        cursor: pointer;
        font-size: var(--text-small, 13px);
        font-weight: 500;
        padding: .75rem 1.25rem .75rem 0;
        overflow: hidden;
        user-select: none;
        text-decoration: none;
        text-transform: none;
        width: 100%;
        position: relative;
        &:focus {
            outline: none;
        }
        ${Device.tablet} {
            font-size: 1rem;
        }
        &:after {
            content: "";
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid var(--color-gray-30, #bfbfbf);
            position: absolute;
            right: 0;
        }
    }

    .mobile-filter__checkbox {
        font-size: var(--text-small, 13px);
        font-weight: 500;
        color: var(--color-gray-30, #bfbfbf);
        ${Device.tablet} {
            font-size: 1rem;
        }
        label {
            width: 100%;
            padding: .75rem 1.25rem .75rem 0;
            font-size: 1em;
        }
        .cb__input:checked {
            ~ .cb__label {
                color: black;
                font-weight: 500;
            }
            ~ .cb__checkmark:after {
                border-color: black;
            }
        }
        .cb__checkmark {
            right: 0;
            left: auto;
            border: none;
            background-color: transparent !important;
            border-color: transparent !important;
            &:after {
                left: 6.5px;
                top: 5px;
                width: 5px;
                height: 10px;
                border-width: 0 1.5px 1.5px 0;
            }
        }
    }
`;

interface MobileFilterProps
{
    drawer: boolean;
    closeDrawer: () => void;
    openDrawer: () => void;
    zIndex: number;
}

const MobileFilter: React.FunctionComponent<MobileFilterProps & MobileFilterStateProps> = (props) =>
{
    const [drawerVisible, setDrawerVisible] = React.useState(false);
    const [dateDrawerVisible, setDateDrawerVisible] = React.useState(false);
    const [categoryDrawerVisible, setCategoryDrawerVisible] = React.useState(false);

    const { startDate, endDate } = props.filters;

    const openCategoryParentDrawer = () =>
    {
        props.openDrawer();
        setCategoryDrawerVisible(false);
    };

    const openDateParentDrawer = () =>
    {
        props.openDrawer();
        setDateDrawerVisible(false);
    };

    const openShowParentDrawer = () =>
    {
        props.openDrawer();
        setDrawerVisible(false);
    };

    const setDateDrawerVisibleFunc = () =>
    {
        props.closeDrawer();
        setDateDrawerVisible(true);
    };

    const setCategoryDrawerVisibleFunc = () =>
    {
        props.closeDrawer();
        setCategoryDrawerVisible(true);
    };

    const setShowDrawerVisibleFunc = () =>
    {
        props.closeDrawer();
        setDrawerVisible(true);
    };

    const handleDatesOnSubmit = (startDate?: Date, endDate?: Date) =>
    {
        props.updateFilters({
            ...props.filters,
            startDate: startDate,
            endDate: endDate
        });
    };

    const updateSelectedCategories = (options: MobileCheckboxOption[]) =>
    {
        const values = options.filter(opt => opt.checked).map((opt) => opt.value);
        props.updateFilters({ ...props.filters, categories: values });
    };

    const updateSelectedShows = (options: MobileCheckboxOption[]) =>
    {
        const showNames = options.filter(opt => opt.checked).map((opt) => opt.value);
        props.updateFilters({ ...props.filters, shows: showNames });
    };

    return (
        <MobileFilterWrap>
            <MobileCheckboxFilter
                drawer={categoryDrawerVisible}
                closeDrawer={openCategoryParentDrawer}
                options={props.categories.map((s) => ({
                    label: s,
                    value: s,
                    checked: props.filters.categories.includes(s)
                }))}
                onSelectionSaved={updateSelectedCategories}
                zIndex={props.zIndex + 1} />

            <MobileCheckboxFilter
                drawer={drawerVisible}
                closeDrawer={openShowParentDrawer}
                options={props.allShows.map((show) => ({
                    label: show.name,
                    value: show.name,
                    checked: props.filters.shows.includes(show.name)
                }))}
                onSelectionSaved={updateSelectedShows}
                zIndex={props.zIndex + 1} />

            <MobileDateForm
                startDate={props.filters.startDate}
                endDate={props.filters.endDate}
                drawer={dateDrawerVisible}
                closeDrawer={openDateParentDrawer}
                onSubmit={handleDatesOnSubmit}
                zIndex={props.zIndex + 1} />

            <Drawer visible={props.drawer} close={props.closeDrawer} placement="right" zIndex={props.zIndex}>

                <div className="drawer__header">
                    <span className="h5 mb-0">Filtre</span>
                    <SecondaryButton size="small" onClick={props.resetFilters} className="drawer__header-btn-right">Nulstil</SecondaryButton>
                </div>

                <div className="drawer__main drawer__main--minus-header-footer">
                    <ul className="drawer__main-ul">
                        <li className="drawer__main-li">
                            <button className="mobile-filter__btn" onClick={setCategoryDrawerVisibleFunc}>
                                <span>Kategori</span>
                            </button>
                        </li>
                        <li className="drawer__main-li">
                            <button className="mobile-filter__btn" onClick={setShowDrawerVisibleFunc}>
                                <span>Forestillinger</span>
                            </button>
                        </li>
                        <li className="drawer__main-li">
                            <button className="mobile-filter__btn" onClick={setDateDrawerVisibleFunc}>
                                <span>Dato</span>
                                <span className="text-gray-30 font-normal">{`${isValid(startDate) ? format(startDate as Date, "dd MMM yyyy") : ""} - ${isValid(endDate) ? format(endDate as Date, "dd MMM yyyy") : ""}`}</span>
                            </button>
                        </li>
                    </ul>
                </div>

                <div className="drawer__footer">
                    <PrimaryButton className="drawer__footer-btn" onClick={props.closeDrawer} size="small">
                        <span className="drawer__footer-icon-left">
                            <Icon name="close" className="w-3 h-3" />
                        </span>
                        <span>Luk</span>
                        <span className="drawer__footer-icon-right"></span>
                    </PrimaryButton>
                </div>
            </Drawer>

            {(drawerVisible || dateDrawerVisible) ? (
                <Backdrop zIndex={props.zIndex - 1} />
            ) : null}
        </MobileFilterWrap>
    );
};

const mapStateToProps = (state: AppState) => ({
    allShows: getShows(state.shows),
    categories: getShowCategories(state.shows),
    filters: getShowFilters(state.shows)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    updateFilters: (filter: ShowFilters) => dispatch(thunkUpdateFilters(filter)),
    resetFilters: () => dispatch(thunkResetFilters())
});

type MobileFilterStateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilter);
